import { render, staticRenderFns } from "./DashboardTablesResponsive.vue?vue&type=template&id=43829d23&scoped=true"
import script from "./DashboardTablesResponsive.vue?vue&type=script&lang=js"
export * from "./DashboardTablesResponsive.vue?vue&type=script&lang=js"
import style0 from "./DashboardTablesResponsive.vue?vue&type=style&index=0&id=43829d23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43829d23",
  null
  
)

export default component.exports